import { render, staticRenderFns } from "./Tariffs.vue?vue&type=template&id=5c54a182&scoped=true&"
import script from "./Tariffs.vue?vue&type=script&lang=ts&"
export * from "./Tariffs.vue?vue&type=script&lang=ts&"
import style0 from "./Tariffs.vue?vue&type=style&index=0&id=5c54a182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c54a182",
  null
  
)

export default component.exports